import StyledModal from "../../common/Modal/StyledModal";
import { ReactComponent as ArrowNextWhite } from "../../../assets/icons/arrowNextWhite.svg";
import { ReactComponent as Warning } from "../../../assets/icons/warning-red.svg";
import Modal from "react-modal";
import styled from "styled-components";
import { useState } from "react";

const OutOfStockModal = ({
  showStockModal,
  customStyles,
  closeModal,
  handlePharmaNameFromModal,
  activateReorder,
}) => {
  const [pharmaName, setPharmaName] = useState("");
  const [error, setError] = useState(false);

  const handleApprove = () => {
    if (!showStockModal.tab) return;
    if (!pharmaName?.length) {
      setError(true);
    } else {
      handlePharmaNameFromModal(pharmaName);
      activateReorder(showStockModal.tab);
      closeModal();
    }
  };

  return (
    <StyledModal>
      <Modal
        isOpen={showStockModal.show}
        style={customStyles}
        contentLabel="Quit Modal"
        overlayClassName="overlay-modal"
        shouldCloseOnOverlayClick={false} // add this to prevent outside click to prevent modal close
      >
        <div className="wrapper-modal">
          <div className="image">
            <Warning />
          </div>
          <div className="main-text-error">This item is out of stock</div>
          <div className="second-text">
            I confirm I have received notification from the distributor that my
            preferred product is out of stock and I wish to order an alternate
            product
          </div>
          <OutOfStockModal.InputWrapper>
            <label htmlFor={"pharmacist_name"}>Please insert your name:</label>
            <input
              maxLength={50}
              type="text"
              name="pharmacist_name"
              id={"pharmacist_name"}
              placeholder={"Insert your name"}
              onChange={(e) => setPharmaName(e.target.value)}
              required
            />
            {error && (
              <div className="error-text" style={{ marginTop: "12px" }}>
                <p style={{ fontSize: "14px", fontStyle: "italic" }}>
                  Required
                </p>
              </div>
            )}
          </OutOfStockModal.InputWrapper>
        </div>
        <div className="wrapper-buttons">
          <button className="cancel mr-6" onClick={closeModal}>
            Cancel
          </button>
          <button className="red-button" onClick={() => handleApprove()}>
            Continue <ArrowNextWhite />
          </button>
        </div>
      </Modal>
    </StyledModal>
  );
};

OutOfStockModal.InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  > label {
    color: #00594c;
    font-size: 13px;
    margin-bottom: 2px;
  }
  > input {
    width: 100%;
    padding: 1rem;
    background-color: #f0f0f0;
    border: none;

    &:focus {
      outline: none;
    }
  }
`;

export default OutOfStockModal;
